import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { routePaths } from '../../urls'
import { postAssessmentIsSynced, alertUser } from '../../actions'
import StatusMarker from '../StatusMarker'
import Checkbox from '../Checkbox.js'

class Assessments extends React.Component {
  componentDidMount() {
    this.unsubscribe = this.context.store.subscribe(() => {
      this.forceUpdate()
    })
  }

  componentWillUnmount() {
    this.unsubscribe()
  }

  generateGroupDivs = groupsList => {
    if (!groupsList) {
      return <div />
    }

    let boxContent = groupsList.map((obj, i) => (
      <div className="group-box" key={i}>
        <div className="title-box">{obj.title}</div>
        {this.generateTable(obj.activities)}
      </div>
    ))

    return <div>{boxContent}</div>
  }

  generateTable = assessmentList => {
    if (!assessmentList) {
      return <div />
    }

    let tableRows = assessmentList.map((obj, i) => (
      <tr key={i}>
        <td>{obj.title}</td>
        <td>
          <Checkbox
            checked={obj.includeInLms}
            onChange={this.handleAssessmentSyncChange.bind(this, obj.id)} // eslint-disable-line react/jsx-no-bind
            title={obj.title}
          />
        </td>
      </tr>
    ))

    return (
      <table className="table">
        <thead>
          <tr>
            <th>Title</th>
            <th>Sync to LMS</th>
          </tr>
        </thead>
        <tbody>{tableRows}</tbody>
      </table>
    )
  }

  handleAssessmentSyncChange = activityId => {
    let { store } = this.context
    let { coursenum } = this.context.store.getState()
    store.dispatch(postAssessmentIsSynced(coursenum, { activityId }))
    alertUser(`Update successful!`, 2000, 'success')
  }

  render() {
    let { canvasUrl, assessments } = this.context.store.getState()
    let showNext = !!canvasUrl
    let setupIcon = showNext ? 'icon_checkmark' : 'icon_notification'

    return (
      <div>
        <div className="canvas-flex-wrapper">
          <div className="canvas-form-container">
            <h2>2. Choose Assessments</h2>
            <p>
              Select which MyEducator assessments you want to appear in
              Brightspace.
            </p>
            {this.generateGroupDivs(assessments.groups)}
            <Link to={routePaths.brightspaceSetup} className="btn btn-myed btn-default btn-default-myed">
              Back
            </Link>
            <Link to={routePaths.brightspaceTest} className="btn btn-myed btn-default btn-default-myed">
              Next
            </Link>
          </div>
          <div className="canvas-statusmarker-container">
            <StatusMarker iconType={setupIcon} />
          </div>
        </div>
      </div>
    )
  }
}

Assessments.contextTypes = {
  store: PropTypes.object,
}

export default Assessments
